module.exports = __webpack_public_path__ + "assets/img/pizza.a425bb6a.png";